var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 310,
    height: 111,
    fill: "#FD7E14"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7045 111L17 41.1818H30.6023L43.1818 92.4886H43.8295L57.2614 41.1818H69.6364L83.1023 92.5227H83.7159L96.2955 41.1818H109.898L90.1932 111H77.7159L63.7386 62.0114H63.1932L49.1818 111H36.7045ZM177.304 76.0909C177.304 83.6136 175.895 90.0568 173.077 95.4205C170.281 100.761 166.463 104.852 161.622 107.693C156.804 110.534 151.338 111.955 145.224 111.955C139.111 111.955 133.634 110.534 128.793 107.693C123.974 104.83 120.156 100.727 117.338 95.3864C114.543 90.0227 113.145 83.5909 113.145 76.0909C113.145 68.5682 114.543 62.1364 117.338 56.7955C120.156 51.4318 123.974 47.3295 128.793 44.4886C133.634 41.6477 139.111 40.2273 145.224 40.2273C151.338 40.2273 156.804 41.6477 161.622 44.4886C166.463 47.3295 170.281 51.4318 173.077 56.7955C175.895 62.1364 177.304 68.5682 177.304 76.0909ZM164.588 76.0909C164.588 70.7955 163.759 66.3295 162.099 62.6932C160.463 59.0341 158.19 56.2727 155.281 54.4091C152.372 52.5227 149.02 51.5795 145.224 51.5795C141.429 51.5795 138.077 52.5227 135.168 54.4091C132.259 56.2727 129.974 59.0341 128.315 62.6932C126.679 66.3295 125.861 70.7955 125.861 76.0909C125.861 81.3864 126.679 85.8636 128.315 89.5227C129.974 93.1591 132.259 95.9205 135.168 97.8068C138.077 99.6705 141.429 100.602 145.224 100.602C149.02 100.602 152.372 99.6705 155.281 97.8068C158.19 95.9205 160.463 93.1591 162.099 89.5227C163.759 85.8636 164.588 81.3864 164.588 76.0909ZM189.261 111V41.1818H233.989V51.7841H201.909V70.7386H230.92V81.3409H201.909V111H189.261ZM245.511 111V41.1818H290.239V51.7841H258.159V70.7386H287.17V81.3409H258.159V111H245.511Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.52 402.335V261.71H132.832V235.668H268.249V261.71H213.561V402.335H187.52ZM281.27 402.335V313.793H247.415V287.751H341.165V313.793H307.311V402.335H281.27Z",
    fill: "#FD7E14"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_554",
    x: 5,
    y: 40.2266,
    width: 289.238,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_554",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoff);
export default __webpack_public_path__ + "static/media/woff.9de9ae99862a20599c1480250c231127.svg";
export { ForwardRef as ReactComponent };